import {
  industryOptions,
  sizeOptions,
  capitalizationOptions,
  mainCategoryOptions,
  companyTypeOptions,
  stocksExchangeOptions,
  lawTypeOptions,
  userRoles,
  departmentOptions,
} from "../data/data";
import { isArray, isEmpty } from "lodash";

export const labelOfIndustry = industry => {
  return industryOptions?.find(item => item.value === industry)?.label ?? "";
};

export const labelOfSize = size => {
  return sizeOptions?.find(item => item.value === size)?.label ?? "";
};

export const labelOfCapitalization = capitalization => {
  return (
    capitalizationOptions?.find(item => item.value === capitalization)?.label ??
    ""
  );
};

export const labelOfFramework = framework => {
  let cat = mainCategoryOptions?.filter(item => item.value === framework);
  return !isEmpty(cat) ? cat[0].label : "";
};

export const labelOfCompanyType = type => {
  return companyTypeOptions?.find(item => item.value === type)?.label ?? "";
};

export const labelOfLawType = type => {
  return lawTypeOptions?.find(item => item.value === type)?.label ?? "";
};

export const labelOfStockEx = stockex => {
  return (
    stocksExchangeOptions?.find(item => item.value === stockex)?.label ?? ""
  );
};

export const labelOfRole = role => {
  return (
    userRoles?.find(item => item.value === role)?.label ?? ""
  );
}

export const labelOfDepartment = department => {
  return (
    departmentOptions?.find(item => item.value === department)?.label ?? ""
  );
}

export const labelOf = (arr, value) => {
  let label = "";
  if (arr && isArray(arr)) {
    label = arr.find(item => item?.value === value)?.label ?? "";
  }
  return label;
};
